import React, { Component } from "react";
import '../assets/templates/LinkingSounds.css';
import LessonInstruction from "../containers/instruction/LessonInstruction";

class LinkingSounds extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      index: 0
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.contentIndex !== this.props.contentIndex){
      this.setState({
        open: false,
      })
    }
  }

  _reset(){
    this.setState({
      open: false
    })
  }

  getHilighted(text){
    let splitText = text.split(/( )/)
    let textObj = []
    for(let i = 0; i < splitText.length; i++){
        if(splitText[i].includes("_")){
            textObj.push({word: splitText[i].replace(/(_)/g," "), highLight: true})
        }else{
            textObj.push({word: splitText[i], highLight: false})
        }
    }
    console.log('textObj: ', textObj)
    return textObj
  }

  render() {
    const { data, audioUrl } = this.props;

    // sets background to white color
    const bgColor = data.type === "instruction" ? "new-bg-color" : "";
    const containerClasses = `default-card ${bgColor}`;

    return (
      <div className={containerClasses}>
        <div>
            {
                data.type === 'instruction' ?
                <>
                  <LessonInstruction
                    instructionText={data.instruction}
                    audioUrl={audioUrl}
                  />
                </>
                :
                <div>   
                    {
                        <div 
                        className="linking-sounds-container">
                            {  
                                this.getHilighted(data.en).map((item, wordIndex)=>{
                                    return(
                                        <h2 key={wordIndex} style={{ 
                                            color: item.highLight ? 'rgb(47, 157, 201)' : 'white',
                                            borderBottom: item.highLight ? '2px solid rgb(47, 157, 201)' : 'none'
                                            }}>
                                            { item.word }
                                        </h2>
                                    )
                                }) 
                            }
                        </div>
                    }
                </div>
                
            }
        </div>
      </div>
    )
  }
}

export default LinkingSounds;
